import React, { useState, useEffect, useRef } from "react";
import "./PPVAnalytics.css"
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { } from "react-bootstrap-table2-paginator";
import {
    MdKeyboardDoubleArrowLeft,
    MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { FaPlay, FaPause, FaClock, FaEye } from "react-icons/fa";
import './UsersRevenue.css'
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminHeader from "../../../components/CommonComponents/AdminHeader";
import NoRecordTable from "../../../components/CommonComponents/NoRecordTable";
import axios from "axios";
import ApexAreaChart from "./Chart/ApexAreaChart";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { IconFilter } from "../../../Assets/MyIcons";
import { formatDate } from "../../../components/CommonMethod/CommonMethods";
import { statusActiveFormatter } from "../../../components/CommonMethod/CommonBoostrapFormatter";
import AdminTable from "../../../components/CommonComponents/AdminTable";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const PPVAnalytics = () => {
    const userAccessToken = getItemToken('access_token');

    const [filteredData, setFilteredData] = useState([]);
    const [apiData, setApiData] = useState([]);
    const [exportData, setExportData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [total, setTotal] = useState('');
    const { fetchRequest } = useMyContext();
    const [formData, setFormData] = useState({
        state: "formData",
        view_type: "list",
        view_type_option: [{
            name: "List",
            value: "list"
        },
        {
            name: "Gallery",
            value: "grid"
        }]
    })

    const [chartData, setChartData] = useState({
        categories: [],
        series: [{
            name: "PPV",
            data: []
        }]
    })

    // Player Analytics Integration
    const [playerAnalytics, setPlayerAnalytics] = useState({
        totalSessions: 0,
        totalWatchHours: 0,
        playCount: 0,
        pauseCount: 0
    });

    // API Configuration for Player Analytics
    const analyticsEndpoint = `${process.env.REACT_APP_Baseurl}/analytics/player`;
    const apiKey = process.env.REACT_APP_ANALYTICS_API_KEY || 'fa-demo-2025-12345678';
    const tenantId = localStorage.getItem('tenant_id');
    const [withOutRefresh, setWithoutRefresh] = useState(false)
    const [loading, setLoading] = useState(false);
    const [editUser, setEditUser] = useState({
        startDate: "",
        endDate: "",
        filterType: "",
    });
    const [defaultData, setDefaultData] = useState({
        filterTypes: [],
        totalAdmin: [],
        totalRegister: [],
        totalSubscriber: []
    })

    const startDateRef = useRef()
    const endDateRef = useRef()
    const filterTypeRef = useRef()
    const fallbackFormatter = (cell) => (cell ? cell : "-");

    const columns = [
        // {
        //     dataField: "sno",
        //     text: "S.No",
        //     formatter: (cell, row, rowIndex) => rowIndex + 1,
        //     headerStyle: { width: "80px", textAlign: "center" },
        //     style: { textAlign: "center" },
        //     isDummyField: true,
        //     colStyle: "text-nowrap",
        // },
        {
            dataField: "user_id",
            text: "User Id ",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "source_type",
            text: "Source",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "title",
            text: "Title",
            formatter: (cell) => cell ? (cell.length > 10 ? cell.substring(0, 10) + '...' : cell) : '-',
            colStyle: "text-nowrap",
        },
        {
            dataField: "source_id",
            text: "Source Id",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "payment_id",
            text: "Transaction Id",
            headerClasses: "userAnalyticsBox",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "currency",
            text: "Currency",

            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "payment_price",
            text: "Price",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "price_paid",
            text: "Price Paid",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "PaymentGateway",
            text: "Type",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "device",
            text: "Device",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "ip_address",
            text: "IP Address",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "countryname",
            text: "Country",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "regionname",
            text: "Region",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "cityname",
            text: "City",
            formatter: fallbackFormatter,
            colStyle: "text-nowrap",
        },
        {
            dataField: "current_status",
            text: "Status",
            formatter: (cell, row) => statusActiveFormatter(cell, row),
            colStyle: "text-nowrap",
        },
        {
            dataField: "createdAt",
            text: "Purchased On",
            formatter: (cell) => formatDate(cell),
            headerClasses: "userAnalyticsBox",
            colStyle: "text-nowrap",
        },
    ];

    const handleInput = (e) => {
        const { name, type, value, checked } = e.target;
        if (name === 'filterType') {
            setEditUser((prevEditUser) => ({
                ...prevEditUser,
                startDate: null,
                endDate: null
            }));
        }
        if (name === "startDate" || name == "endDate") {
            setEditUser((prevEditUser) => ({
                ...prevEditUser,
                filterType: null,
            }));
            if (editUser?.startDate && !editUser?.endDate) {
                endDateRef.current.focus();
            }
            if (editUser?.endDate && !editUser?.startDate) {
                startDateRef.current.focus();
            }
        }
        setEditUser((prevEditUser) => ({
            ...prevEditUser,
            [name]: value,
        }));
    };

    const fetchData = async () => {
        setLoading(true)
        try {

            const response = await fetchRequest({
                method: "GET",
                url: `${process.env.REACT_APP_Baseurl}/admin/ppv-purchased-analytics`,
                params: {
                    limit, page, filter_type: editUser?.filterType, start_date: editUser?.startDate, end_date: editUser?.endDate, search: searchText,
                },
                data: {},
            });
            const userData = response?.purchases;
            const paginationData = response?.pagination;

            const FilterHelp = userData.map((item) => {
                const statusText = item?.current_status == 1 ? "ACTIVE" : "INACTIVE";
                return { ...item, current_status: statusText };
            });
            setApiData(FilterHelp);
            setChartData((prev) => ({
                ...prev,
                categories: response?.monthly_revenue_months,
                series: [
                    {
                        name: "PPV",
                        data: response?.monthly_revenue_counts,
                    }
                ],
            }))
            setFilteredData(FilterHelp);
            setTotal(paginationData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    // Fetch all data for export (without pagination)
    const fetchAllDataForExport = async () => {
        try {
            const response = await fetchRequest({
                method: "GET",
                url: `${process.env.REACT_APP_Baseurl}/admin/ppv-purchased-analytics`,
                params: {
                    limit: total?.totalItems || 10000, // Use total items or a large number
                    page: 1,
                    filter_type: editUser?.filterType,
                    start_date: editUser?.startDate,
                    end_date: editUser?.endDate,
                    search: searchText,
                },
                data: {},
            });
            const userData = response?.purchases;
            const FilterHelp = userData.map((item) => {
                const statusText = item?.current_status == 1 ? "ACTIVE" : "INACTIVE";
                return { ...item, current_status: statusText };
            });
            setExportData(FilterHelp);
        } catch (error) {
            console.error("Error fetching export data:", error);
        }
    };

    const fetchFilterTypeData = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/filter-types`, { headers: userAccessToken });
            const types = response?.data?.FilterTypes;
            setDefaultData((prev) => ({
                ...prev,
                filterTypes: types
            }))
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    // Fetch Player Analytics Data
    const fetchPlayerAnalyticsData = async () => {
        try {
            const headers = {
                'X-API-Key': apiKey,
                ...(tenantId ? { 'X-Tenant-ID': tenantId } : {}),
                'Content-Type': 'application/json'
            };
            const params = {
                startDate: editUser?.startDate,
                endDate: editUser?.endDate,
                filterType: editUser?.filterType
            };
            const res = await axios.get(`${analyticsEndpoint}/summary`, { headers, params });
            if (res?.data) {
                setPlayerAnalytics({
                    totalSessions: res.data.totalSessions || 0,
                    totalWatchHours: res.data.totalWatchHours || 0,
                    playCount: res.data.playCount || 0,
                    pauseCount: res.data.pauseCount || 0
                });
            }
        } catch (err) {
            console.error('Error fetching player analytics:', err);
        }
    };

    const handleReload = () => {
        setWithoutRefresh(!withOutRefresh);
        setApiData([])
        setFilteredData([])
        setEditUser((prev) => ({
            ...prev,
            startDate: "",
            endDate: "",
            filterType: "",
        }))
    }

    const fetchFilterDurationData = async () => {
        setLoading(true)
        const requiredData = {
            filter_type: editUser?.filterType,
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/ppv-purchased-filter-analytics`, JSON.stringify(requiredData), { headers: userAccessToken });
            const userData = response?.data?.purchases;
            setApiData(userData);
            setChartData((prev) => ({
                ...prev,
                categories: response?.data?.monthly_revenue_months,
                series: [
                    {
                        name: "PPV",
                        data: response?.data?.monthly_revenue_counts,
                    }
                ],
            }))
            setFilteredData(userData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    const fetchFilterStartEndDateData = async () => {
        setLoading(true)
        const requiredData = {
            start_Date: editUser?.startDate,
            end_Date: editUser?.endDate
        }
        try {
            const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/ppv-purchased-date-filter-analytics`, JSON.stringify(requiredData), { headers: userAccessToken });
            const userData = response?.data?.purchases;
            setApiData(userData);
            setChartData((prev) => ({
                ...prev,
                categories: response?.data?.monthly_revenue_months,
                series: [
                    {
                        name: "PPV",
                        data: response?.data?.monthly_revenue_counts,
                    }
                ],
            }))
            setFilteredData(userData);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };

    useEffect(async () => {
        fetchData();
        fetchFilterTypeData();
        fetchPlayerAnalyticsData();
    }, [withOutRefresh]);

    // Fetch all data for export whenever filters change
    useEffect(() => {
        if (total?.totalItems) {
            fetchAllDataForExport();
        }
    }, [total, editUser, searchText]);

    useEffect(async () => {
        fetchData();
    }, [withOutRefresh, page, limit, searchText]);

    useEffect(() => {
        if (editUser?.startDate && editUser?.endDate) {
            fetchFilterStartEndDateData();
            fetchPlayerAnalyticsData();
        }
        else if (editUser?.filterType) {
            fetchFilterDurationData();
            fetchPlayerAnalyticsData();
        }
        else {
            fetchData();
            fetchPlayerAnalyticsData();
        }
    }, [editUser])


    const options = {
        pageStartIndex: 1,
        paginationSize: 3,
        sizePerPage: 10,
        sizePerPageList: [
            { text: '5', value: 5, id: "optionOne" },
            { text: '10', value: 10, id: "optionTwo" },
            { text: 'All', value: total?.totalItems, id: "optionThree" }
        ]
    };

    const handleSort = (field) => {
        const sortedData = [...filteredData].sort((a, b) => {
            if (a[field] < b[field]) return -1;
            if (a[field] > b[field]) return 1;
            return 0;
        });
        setFilteredData(sortedData);
    };

    const handlePageChange = (page) => {
        setPage(page);
    };

    const handleSizePerPageChange = (e) => {
        setLimit(Number(e.target.value));
        console.log("target.value", e.target.value);
        setPage(1);
    };

    return (
        <div className="mb-3">
            <h4 className="admin-title mb-3 theme-text-color text-md-start"> <MessageBox text={'PPV Analytics'} classname="theme-text-color" /></h4>

            {/* Player Analytics Summary Cards */}
            <div className="row g-4 mb-3">
                <div className="col-md-3 col-sm-6">
                    <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
                        <div className="icon-circle bg-primary-subtle text-primary me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
                            <FaEye style={{ width: "20px", height: "20px" }} />
                        </div>
                        <div>
                            <div className="fs-4 fw-bold mb-1">{playerAnalytics?.totalSessions || 0}</div>
                            <div className="text-muted small">PPV Sessions</div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 col-sm-6">
                    <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
                        <div className="icon-circle bg-success-subtle text-success me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
                            <FaClock style={{ width: "20px", height: "20px" }} />
                        </div>
                        <div>
                            <div className="fs-4 fw-bold mb-1">{Number(playerAnalytics?.totalWatchHours || 0).toFixed(1)}h</div>
                            <div className="text-muted small">Watch Hours</div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 col-sm-6">
                    <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
                        <div className="icon-circle bg-info-subtle text-info me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
                            <FaPlay style={{ width: "20px", height: "20px" }} />
                        </div>
                        <div>
                            <div className="fs-4 fw-bold mb-1">{playerAnalytics?.playCount || 0}</div>
                            <div className="text-muted small">Play Events</div>
                        </div>
                    </div>
                </div>

                <div className="col-md-3 col-sm-6">
                    <div className="p-4 rounded-4 d-flex align-items-center bg-white shadow-sm border theme-border-color h-100">
                        <div className="icon-circle bg-warning-subtle text-warning me-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 56, height: 56 }}>
                            <FaPause style={{ width: "20px", height: "20px" }} />
                        </div>
                        <div>
                            <div className="fs-4 fw-bold mb-1">{playerAnalytics?.pauseCount || 0}</div>
                            <div className="text-muted small">Pause Events</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="theme-bg-color p-3 rounded-2 mb-3">
                <div className="d-flex align-items-center p-3">
                    <div className="col-12">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <MessageBox text="PPV Analytics" />
                            <div className="d-flex align-items-center justify-content-between gap-3">
                                {/* {editUser?.filterType == 'Last_7_Days' && ( */}
                                <>
                                    <div className="position-relative">
                                        <input type="date" name="startDate" value={editUser?.startDate || ''} max={editUser?.endDate || new Date().toISOString().split('T')[0]} onChange={handleInput} ref={startDateRef} className="filterTypeCustom  calender rounded-5 theme-text-color border border-1 theme-border-color " />
                                    </div>
                                    <div className="position-relative">
                                        <input type="date" name="endDate" value={editUser?.endDate || ''} min={editUser?.startDate || ''} max={new Date().toISOString().split('T')[0]} onChange={handleInput} ref={endDateRef} className="filterTypeCustom calender rounded-5  theme-text-color border border-1 theme-border-color " />
                                    </div>
                                </>
                                {/* )} */}
                                <div className="position-relative">
                                    <IconFilter styled={{ width: "18px", height: "18px", className: "position-absolute filterIcon" }} />
                                    <select name="filterType" value={editUser?.filterType || ''} onChange={handleInput} className=" rounded-5 filterTypeCustom border border-1 theme-border-color  theme-text-color" ref={filterTypeRef}>
                                        <option value='' className="theme-bg-color theme-text-color" >Filter</option>
                                        {defaultData?.filterTypes?.map((item, index) => {
                                            return <option key={item?.filter_type} value={item?.filter_type} className="theme-bg-color theme-text-color">{item?.name}</option>
                                        })}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <ApexAreaChart users={apiData} chartData={chartData} />
                    </div>
                </div>
                {/* <div className="d-flex align-items-center pb-3">
                    <div className="col-3 d-flex align-items-center">
                        <select name="filterType" value={editUser?.filterType || ''} onChange={handleInput} className="form-select custom-placeholder   border border-1 theme-border-color  theme-text-color" ref={filterTypeRef}>
                            <option value='' className="theme-bg-color theme-text-color" >Select Filter Type</option>
                            {defaultData?.filterTypes?.map((item, index) => {
                                return <option key={item?.filter_type} value={item?.filter_type} className="theme-bg-color theme-text-color">{item?.name}</option>
                            })}
                        </select>
                    </div>

                    <div className="col-9 px-4 d-flex align-items-center justify-content-end">
                        <div className="col-3 pe-2">
                            <input type="date" name="startDate" value={editUser?.startDate || ''} max={editUser?.endDate || ''} onChange={handleInput} ref={startDateRef} className="rs-input py-3 px-3 custom-placeholder theme-text-color border border-1 theme-border-color " />
                        </div>
                        <div className="col-3 pe-2">
                            <input type="date" name="endDate" value={editUser?.endDate || ''} min={editUser?.startDate || ''} onChange={handleInput} ref={endDateRef} className="rs-input py-3 px-3 custom-placeholder theme-text-color border border-1 theme-border-color " />
                        </div>

                    </div>
                </div> */}
            </div>
            <div className="theme-bg-color p-3 rounded-2">
                <div className=" bootstrapTable scroll-active multi-delete-width" >
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 gap-3">
                        <div className="position-relative" style={{ maxWidth: '300px' }}>
                            <input
                                type='text'
                                placeholder="Search"
                                className="filter form-control theme-text-color theme-border-secondary theme-bg-color-secondary"
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{ paddingRight: searchText ? '35px' : '12px' }}
                            />
                            {searchText && (
                                <button
                                    type="button"
                                    onClick={() => setSearchText('')}
                                    className="btn btn-link position-absolute top-50 end-0 translate-middle-y p-0 me-2"
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        lineHeight: 1,
                                        color: '#6c757d',
                                        textDecoration: 'none'
                                    }}
                                    aria-label="Clear search"
                                >
                                    ×
                                </button>
                            )}
                        </div>
                        <AdminHeader hideExport hideSearch reduceData={exportData.length > 0 ? exportData : filteredData} originalData={exportData.length > 0 ? exportData : apiData} fileName={'PPV-ANALYTICS-LIST'} reloadAction={handleReload} customppv reload loading={loading} />
                    </div>
                    {/* <BootstrapTable keyField="id" pagination={paginationFactory(options)} columns={columns} data={loading ? [] : filteredData} className="no-border-table theme-text-color " noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />} hover /> */}
                    <AdminTable
                        data={filteredData}
                        loading={loading}
                        options={options}
                        handlePageChange={handlePageChange}
                        page={page}
                        pagination={total}
                        handleSizePerPageChange={handleSizePerPageChange}
                        columns={columns}
                        limit={limit}
                        onSort={handleSort}
                        viewType={formData?.view_type}
                        className="no-border-table theme-text-color "
                    />
                </div>
            </div>
        </div>
    );
};

export default PPVAnalytics;
